/**
 * User preferences stored at a root user level supports:
 * company, location, schedule and worker level preferences.
 */
import { UserCompanyPreference } from './user-company-preference';
import { LocationPreference } from './location-preference';
import { PreferenceSortType } from './preference-sort-type';
import { PreferenceGroupType } from './preference-group-type';

export class UserPreference {
    sort: PreferenceSortType;
    group: PreferenceGroupType;
    company?: {
        [id: string]: UserCompanyPreference;
    };
    location?: {
        [id: string]: LocationPreference;
    };
    previousLocation?: LocationPreference;
    ihdSites: any[]
}
